import { render, staticRenderFns } from "./LocalesSwitcher.vue?vue&type=template&id=acc8325c&"
import script from "./LocalesSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LocalesSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./LocalesSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports